import { ENDPOINTS } from "../../redux/apiConfig";

export const handleVerifyOutlook = (displayName, onSuccess, onClose) => {
  const url = `${ENDPOINTS.BS_OUTLOOK.OUTLOOK_AUTH}?displayName=${encodeURIComponent(displayName)}`;

  const width = 500;
  const height = 600;

  const left = window.screenX + (window.outerWidth - width) / 2;
  const top = window.screenY + (window.outerHeight - height) / 2;

  const popup = window.open(
    url,
    "Outlook OAuth",
    `width=${width},height=${height},left=${left},top=${top}`,
  );
  const messageListener = (event) => {
    if (event.data?.type === "OUTLOOK_CONNECTED") {
      clearInterval(timer);
      window.removeEventListener("message", messageListener);

      if (onSuccess) {
        console.log(event.data?.email);

        console.log(event.data.authId);
        onSuccess({
          email: event.data?.email || event.data?.userEmail || null,
          authId: event.data?.authId || null,
        }); // this will create IntegrationAccessBS
      }
      if (onClose) onClose();
    }
  };
  window.addEventListener("message", messageListener);

  //  Fallback: if user manually closes popup without completing OAuth
  const timer = setInterval(() => {
    if (popup.closed) {
      clearInterval(timer);
      window.removeEventListener("message", messageListener);
      console.log("Outlook popup closed");
      if (onClose) onClose();
    }
  }, 1000);
};
